import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { AgeBreadcrumb } from "../components/AgeBreadcrumb";
import { AgeCalculator } from "../components/AgeCalculator";
import { AgeExplainer } from "../components/AgeExplainer";

export function AgeCalculatorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <AgeBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.age_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.age_intro()}
          </p>
        </header>

        <AgeCalculator />

        <AgeExplainer
          howTo={m.age_howto()}
          faqs={[
            { q: m.age_faq1_q(), a: m.age_faq1_a() },
            { q: m.age_faq2_q(), a: m.age_faq2_a() },
            { q: m.age_faq3_q(), a: m.age_faq3_a() },
            { q: m.age_faq4_q(), a: m.age_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
